import moment from 'moment';
import axios from 'axios';

import config from '@config';

import { ENDPOINTS } from '@constants';
import { KEYS } from '@opp/ui-kit';

import {
  AcSaveState,
} from '@opp/ui-kit';

export const AcTokenRefresher = (_, callback) => {
  return AcRefreshIfRequired()
    .then((response) => {
      return response;
    })
    .catch(() => {
      // Token refresh failed, call the provided callback if given...
      if (callback) callback();
    });
};

const AcRefreshIfRequired = () => {
  return new Promise((resolve, reject) => {
    const Client = axios.create({
      baseURL: config.pkce.accounts_uri,
      timeout: 1000 * 60,
      maxContentLength: 10000,
      responseType: 'json',
      responseEncoding: 'utf8',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'X-OPP': 'MyOPP',
      },
    });

    const data = {
      grant_type: 'refresh_token',
      client_id: process.env.CLIENT_ID,
    };

    Client.post(ENDPOINTS.AUTH.REFRESH_TOKEN, data)
      .then((response) => {
        const { data } = response;

        let account = data;

        const { access_token, expires_in, token_type } = account;

        const expires_at = moment().add(expires_in, 'seconds').format('X');
        AcSaveState(KEYS.EXPIRES_AT, expires_at);

        if (access_token) AcSaveState(KEYS.ACCESS_TOKEN, access_token);
        if (token_type) AcSaveState(KEYS.TOKEN_TYPE, token_type);
        if (account)
          AcSaveState(KEYS.ACCOUNT, { ...account, expires_at: expires_at });

        const handleAuthenticationEvent = new CustomEvent(
          'handleAuthentication',
          { detail: account }
        );
        window.dispatchEvent(handleAuthenticationEvent);

        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
